// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-sucess{color:#1bc943!important}.text-danger{color:#f83245!important}.card__no-task{max-width:910px;margin:auto}", ""]);
// Exports
module.exports = exports;
